<script>
export default {
  name: "index.vue",
  props: ["steps"],
};
</script>

<template>
<div class="flex flex-column" >
  <div v-for="(step , index) in steps" :key="index">
    <div class="d-flex align-center">
      <span class="chip-step">
        {{index + 1}}
      </span>
      <span class="font-Regular-20 ms-4">{{step.title}}</span>
    </div>
    <div class="d-flex py-5" style="width: 100%">
      <div class="line"></div>
      <div class="ps-10"  style="width: 100%">
        <slot :name="`step${index+1}`"></slot>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
.line {
  width: 2px;
  background: var(--v-gray8-base);
  margin-inline-start: 20px;
}
.chip-step{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--v-gray8-base);
  border-radius: 100%;
}
</style>